import { render, staticRenderFns } from "./TheProfitSurcharge.vue?vue&type=template&id=56355771&scoped=true&"
import script from "./TheProfitSurcharge.vue?vue&type=script&lang=js&"
export * from "./TheProfitSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56355771",
  null
  
)

export default component.exports